Vue.component("IdleScreen", {

    template: `
        <div id="idle-screen" v-if="enabled">
            <transition
                name="custom-classes-transition"
                :enter-active-class="enterAnimation"
                v-on:after-enter="onEnterComplete"
                :leave-active-class="leaveAnimation">
                <div class="idle-screen__content" v-if="visible" @click="hide">
                    <component  
                        :is="componentType" 
                        :contentId="dummyContentId" 
                        :useInlineData="useInlineData" 
                        :inlineData="inlineData"></component>
                </div>
            </transition>
        </div>
    `,

    data () {
        return {
            enabled: config.IDLE.settings.enabled,

            visible: false,
            dummyContentId: -1,
            componentType: config.IDLE.settings.component.name,
            inlineData: config.IDLE.settings.component.data,
            useInlineData: true, 
            enterAnimation: config.IDLE.settings.enterAnimation,
            leaveAnimation: config.IDLE.settings.leaveAnimation,
        }
    },

    mounted() {
        window.app.radio.$on("ENTER_IDLE_MODE", this.show);
        this.navigateOnClose  = config.IDLE.navigateOnClose || true;
        this.gotoRouteOnClose = config.IDLE.gotoRouteOnClose || "/scene/0";
    },

    methods: {

        navigate () {
            if(this.navigateOnClose) {
                if(this.$route.path !== this.gotoRouteOnClose)
                    this.$router.push(this.gotoRouteOnClose);
            }
        },
        hide () {
            this.visible = false;
        },
        show () {
            this.visible = true;
        },
        onEnterComplete () {
            this.navigate();
        }
    }


});